require('../../style/base.css');
require('../index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.13.2@vant/lib/index-bar/style/index.js
// module id = 310
// module chunks = 319